import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('serviceTime', serviceTime);

/* @ngInject */
function serviceTime(moment, $translate) {
  return function (valueMs) {

    if (valueMs == null || isNaN(Number(valueMs))) return '—';

    const totalMinutes = Math.floor(Math.max(0, valueMs) / 60000);

    if (totalMinutes <= 59) {
      return $translate.instant('X_SERVICE_TIME_MIN_ONLY', {
        minutes: totalMinutes
      });
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return $translate.instant('X_SERVICE_TIME', {
      hours,
      minutes
    });
  }
}
